"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelDetailsDef = void 0;
const joi_1 = __importDefault(require("joi"));
const __1 = require("..");
exports.PanelDetailsDef = Object.assign(Object.assign({}, __1.daoObjSchemaDef), { businessUnitId: joi_1.default.string().required(), sessionid: joi_1.default.number().required(), creditorNumber: joi_1.default.number().required(), panel: joi_1.default.object({
        id: joi_1.default.number().required(),
        name: joi_1.default.string().required(),
    }), panelDetails: joi_1.default.array().items(joi_1.default.object({
        assessment: joi_1.default.object({
            code: joi_1.default.string().required(),
            version: joi_1.default.number().required(),
            componentId: joi_1.default.string().required(),
        }),
        examiners: joi_1.default.object({
            creditorNumber: joi_1.default.number().required(),
            name: joi_1.default.string().required(),
            roleId: joi_1.default.string().required(),
            roleName: joi_1.default.string().required(),
            examinerNumber: joi_1.default.string().required(),
        }),
        supervisor: joi_1.default.object({
            creditorNumber: joi_1.default.number().required(),
            name: joi_1.default.string().required(),
            roleId: joi_1.default.string().required(),
            roleName: joi_1.default.string().required(),
            examinerNumber: joi_1.default.string().required(),
        }),
        centresApportioned: joi_1.default.array().items(joi_1.default.object({
            id: joi_1.default.string().optional(),
            name: joi_1.default.string().optional(),
            zone: joi_1.default.string().allow(null).optional(),
            zoneId: joi_1.default.string().allow(null).optional(),
        })),
    })) });
